// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IiPX","top":"styles_top__TZALe","left":"styles_left__2eZXK","description":"styles_description__1yw8I"};